import React from 'react';
import { Row, Modal, Spin } from 'antd';
import { useDispatch } from 'react-redux';
import { setAvailableMunicipalitiesModalVisibility } from '../TaxTrax.actions';
import { AvailableMunicipalities } from '../models';
import { LOADING, Sizes } from 'common/constants';
import TaxTraxMunicipalitiesTable from './TaxTraxMunicipalitiesTable';
import globalStyles from 'common/global.module.scss';

const TaxTraxAvailableMunicipiliaties: React.FC<{
  isVisible: boolean;
  loading: boolean;
  municipalities: AvailableMunicipalities;
}> = ({ isVisible, loading, municipalities }) => {
  const dispatch = useDispatch();

  const closeModal = () => {
    dispatch(setAvailableMunicipalitiesModalVisibility(false));
  };

  return (
    <Modal
      title={`TaxTrax - Available Municipalities`}
      visible={isVisible}
      onCancel={() => closeModal()}
      footer={null}
      width="auto"
      className={globalStyles.modalSpacing}
    >
      <Spin
        spinning={loading && !municipalities}
        size={Sizes.LARGE}
        tip={LOADING}
      >
        <Row type="flex">
          <TaxTraxMunicipalitiesTable municipalities={municipalities} />
        </Row>
      </Spin>
    </Modal>
  );
};

export default TaxTraxAvailableMunicipiliaties;
